import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE, SHOW_MESSAGE, SET_FAV_ICON, SET_LOGO, IS_PASSWORD_CHANGE, ATTENDANCE_UPDATED, SET_DATE_FORMAT, SET_TIME_CALCULATION_MODE, SET_AUTO_SHIFT_ENABLED } from "../../constants/ActionTypes";

export const fetchStart = () => {
  return {
    type: FETCH_START
  }
};

export const fetchSuccess = () => {
  return {
    type: FETCH_SUCCESS
  }
};

export const fetchError = (error) => {
  return {
    type: FETCH_ERROR,
    payload: error
  }
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  }
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  }
};

export const setFavIcon = (base64) => {
  return {
    type: SET_FAV_ICON,
    payload: base64
  }
}

export const setLogo = (base64) => {
  return {
    type: SET_LOGO,
    payload: base64
  }
}

export const setIsPasswordChange=(IsPasswordChange)=>{
  return{
    type:IS_PASSWORD_CHANGE,
    payload:IsPasswordChange
  }
}

export const updateAttendance = () => ({
  type: ATTENDANCE_UPDATED,
});

// Company-wide Date Format setting (fetched once, cached in Redux so any
// component can read it via the useCompanyDateFormat hook).
export const setDateFormat = (dateFormat) => {
  return {
    type: SET_DATE_FORMAT,
    payload: dateFormat,
  }
}

// Company-wide time calculation mode ("hours"|"minutes", effective-dated —
// this is the mode currently in effect today, not a flat toggle). Fetched
// once (see AttendanceSettings.js's existing getAttendanceSettings call,
// which now also returns this field) and cached here so every other screen
// reads it via the useCompanyTimeCalculationMode hook instead of each
// independently calling /time-calculation-mode/history.
export const setTimeCalculationMode = (timeCalculationMode) => {
  return {
    type: SET_TIME_CALCULATION_MODE,
    payload: timeCalculationMode,
  }
}

// Company-wide Auto Shift flag. Off by default; every Auto Shift / Shift Group
// screen reads it through useAutoShiftEnabled so a company with the setting off
// sees exactly the product it had before.
export const setAutoShiftEnabled = (enabled) => {
  return {
    type: SET_AUTO_SHIFT_ENABLED,
    payload: enabled === true,
  }
}
